export default "query getGlossVersion {\n  version\n}\n"